import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { XSquare } from 'lucide-react';
export function Failures() {
  const failures = [{
    title: 'The "Multivitamin" Approach',
    desc: 'Fails because isolated, synthetic nutrients lack the biological synergy required to actually cross the cellular wall.'
  }, {
    title: 'Symptom Suppression (OTC meds)',
    desc: 'Works against you by turning off your body\'s natural "Heat-Shock" weapons, actually allowing pathogens to replicate longer.'
  }, {
    title: 'Waiting for Centralized "Guidance"',
    desc: 'A losing game; by the time a protocol is public, the window for effective prevention has already slammed shut.'
  }];
  return <section className="py-14 md:py-16 bg-bio-black" data-id="element-50">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-51">
        <FadeIn data-id="element-52">
          <SectionLabel text="DIAGNOSTIC // FAILED STRATEGIES" data-id="element-53" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-54">
            WHY WHAT YOU TRIED DIDN'T WORK
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-55">
          {failures.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-56">
              <div className="border border-bio-gray/50 bg-bio-panel p-8 h-full relative overflow-hidden group hover:border-bio-amber/50 transition-colors" data-id="element-57">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-58">
                  <XSquare className="w-24 h-24 text-bio-amber" data-id="element-59" />
                </div>

                <XSquare className="w-8 h-8 text-bio-amber mb-6 relative z-10" data-id="element-60" />
                <h3 className="text-xl font-bold text-white mb-4 relative z-10 tracking-wide" data-id="element-61">
                  {item.title}
                </h3>
                <p className="text-bio-muted relative z-10 font-light leading-relaxed" data-id="element-62">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}